// extracted by mini-css-extract-plugin
export default {"section":"groupTreatmentPlans_section__z3yF+","plan":"groupTreatmentPlans_plan__b98nx","viewBtn":"groupTreatmentPlans_viewBtn__WWjT5","eyeIcon":"groupTreatmentPlans_eyeIcon__Km-y6"};